import { GlobalAxios } from "../axios/axios-config";
import { ITotemDevice, ITotemDevicePayload } from "../models/totem-devices";

const SALES_CONTRACT_HISTORY_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/TotemDevice/";

export const createTotemDevice = (item: ITotemDevicePayload) => {
  return GlobalAxios.post(SALES_CONTRACT_HISTORY_ROUTE, item);
};

export const getTotemDeviceById = (id: string) => {
  return GlobalAxios.get<ITotemDevice>(SALES_CONTRACT_HISTORY_ROUTE + id);
};

export const updateTotemDeviceById = ({
  item,
  id,
}: {
  item: ITotemDevicePayload;
  id: string;
}) => {
  return GlobalAxios.put(SALES_CONTRACT_HISTORY_ROUTE + id, item);
};
